<script>
import Layout from './app'
import Breadcrumbs from '@components/bread-crumbs'

export default {
  components: { Layout, Breadcrumbs },
}
</script>

<template>
  <Layout>
    <v-toolbar
      flat
      color="grey lighten-5"
    >
      <breadcrumbs />
      <v-spacer />
      <slot name="actionButton" />
    </v-toolbar>
    <slot />
  </Layout>
</template>
